var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-container"},[_vm._v(" 财务报告 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }